var render = function render(){var _vm=this,_c=_vm._self._c;return (this.userId == this.currentUserId)?_c('a',{attrs:{"href":_vm.userEditRoute}},[_vm._v("\n    "+_vm._s(_vm.$t('user.edit'))+"\n    "),_c('i',{staticClass:"fas fa-ellipsis-h tw-self-center tw-ml-2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }